function filterPublic(array, type) {
    switch (type) {
    case 'All':
        return array;
    case 'Public':
        return array.filter(company => company.javna === true);
    case 'Private':
        return array.filter(company => company.javna === false);
    default:
        return array;
    }
}

export default filterPublic;
